module.exports = __webpack_public_path__ + "static/media/Terminal.a3ae8cce.png";